/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as Msdyn365 from '@msdyn365-commerce/core';
import { generateCacheKey } from '@msdyn365-commerce-modules/retail-actions';
import { ICommerceApiSettings } from '@msdyn365-commerce/core';
import { getAvailableDatesAsync } from './DataActionExtension.g';
import { IGetAvailableDatesResponse } from './DataServiceEntities.g';

/**
 * GetAllowedDays Input Action
 */
export class GetAvailableDatesInput implements Msdyn365.IActionInput {
    public leadDate: string;
    public leadTimeDays: number;
    private readonly apiSettings: ICommerceApiSettings;
    public constructor(leadDate: string, leadTimeDays: number, apiSettings: ICommerceApiSettings) {
        this.leadDate = leadDate;
        this.leadTimeDays = leadTimeDays;
        this.apiSettings = apiSettings;
    }

    // TODO: Determine if the results of this get action should cache the results and if so provide
    // a cache object type and an appropriate cache key
    public getCacheKey = () =>
        generateCacheKey(this.apiSettings, { key: 'LeadDate', value: this.leadDate }, { key: 'LeadTimeDays', value: this.leadTimeDays });
    public getCacheObjectType = () => 'string[]';
    public dataCacheType = (): Msdyn365.CacheType => 'request';
}

// TODO: Create a data model here or import one to capture the response of the action
export interface IGetAllowedDaysData {
    text: string;
}

/**
 * TODO: Use this function to create the input required to make the action call
 */
const DateofDeliveryInput = (args: Msdyn365.ICreateActionContext<{ leadDate: string; leadTimeDays: number }>): Msdyn365.IActionInput => {
    return new GetAvailableDatesInput(args.config?.leadDate || '', args.config?.leadTimeDays || 0, args.requestContext.apiSettings);
};

/**
 * TODO: Use this function to call your action and process the results as needed
 */
async function getAvailableDates(input: GetAvailableDatesInput, ctx: Msdyn365.IActionContext): Promise<IGetAvailableDatesResponse> {
    const response = await getAvailableDatesAsync({ callerContext: ctx }, input.leadDate, input.leadTimeDays);
    return Promise.resolve(response);
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<IGetAvailableDatesResponse>>getAvailableDates,
    // TODO: Give your data action a unique id
    id: 'GetAvailableDates',
    input: DateofDeliveryInput
    // TODO: Uncomment the below line if this is a meant to be a batched data action
    // isBatched: true
});
